import { ReactElement } from 'react';
import { EmailFilter, Props } from 'NHPTemplates.mod/Form/components/email-filter';
import { updateFormState } from 'NHPTemplates.mod/Form/utils';

export function EmailFilterContainer(props: Props): ReactElement {
	return <EmailFilter { ...props } storeUpdater={ updateFormState } />;
}
